import { useState } from 'react'
import { Link } from 'react-router-dom'

interface UpgradeBannerProps {
  remaining: number
}

export function UpgradeBanner({ remaining }: UpgradeBannerProps) {
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null

  return (
    <div className="border border-amber-500/30 bg-amber-500/5 px-4 py-3 flex items-center justify-between">
      <p className="text-sm text-amber-600">
        You have {remaining} generation{remaining !== 1 ? 's' : ''} left.{' '}
        <Link to="/pricing" className="underline hover:text-amber-500">
          Pick a plan
        </Link>{' '}
        to keep creating.
      </p>
      <button
        onClick={() => setDismissed(true)}
        className="text-amber-600 hover:text-amber-500 ml-4 text-sm"
        aria-label="Dismiss"
      >
        &#10005;
      </button>
    </div>
  )
}
